import React, { useContext, useState } from "react";
import Slider from "react-slick";
import Images from "../../Helpers/Images";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Form, InputGroup } from "react-bootstrap";
import { EyeFill, EyeSlashFill, Facebook } from "react-bootstrap-icons";
import ThemeButtom from "../../Components/ThemeButtom";
import { Link, useNavigate } from "react-router-dom";
import FacebookLogin from "react-facebook-login";
import { Auth } from "../../Contexts/AuthContext";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import { Notification, Placeholder, toaster } from "rsuite";
import hasError from "../../Helpers/ErrorHelper";

const InfluencerLogin = () => {
  const { setAuth, setFavoriteCounts } = useContext(Auth);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [myPages, setMyPages] = useState([]);
  const [facebookAccessToken, setFacebookAccessToken] = useState("");
  const [accessData, setAccessData] = useState();
  const [showPageModal, setShowPageModal] = useState(false);
  const [validataionErrors, setValidataionErrors] = useState([]);
  const [formData, setFormData] = useState({
    email: "qrewea@gmail.com",
    password: "12345678",
  });

  const navigate = useNavigate();
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    fade: true,
    cssEase: "linear",
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    const collect = {
      ...formData,
      [name]: value,
    };

    const IsError = validataionErrors?.find((v) => v.field === name);
    if (IsError !== undefined) {
      const errors = validataionErrors?.filter((v) => v.field !== name);
      setValidataionErrors(errors);
    }

    setFormData(collect);
  };
  // api integration
  const socialLogin = (data) => {
    setIsLoading(true);
    let confing = {
      url: ApiUrl.influencerSocialLogin,
      method: "POST",
      body: { ...data, provider: "FACEBOOK" },
    };

    APIRequest(
      confing,
      (res) => {
        setIsLoading(false);
        if (res?.need_fb_page) {
          setMyPages(res?.pages);
          setFacebookAccessToken(res?.longLivedtoken);
          setAccessData(res?.access_data);
          setShowPageModal(true);
        } else {
          navigate("/campaigns");
          localStorage.setItem("token", res?.token);
          localStorage.setItem("user", JSON.stringify(res.user));
          localStorage.setItem("userRole", "INFLUENCER");
          setFavoriteCounts(res?.total_favorite_counts);
          localStorage.setItem("favCounts", res?.total_favorite_counts);
          setAuth({
            userRole: "INFLUENCER",
            user: res.user,
            token: res?.token,
          });
          window.location.reload();
        }
      },
      (err) => {
        setIsLoading(false);
        if (err.response.status === 422) {
          setValidataionErrors(err.response.data.errors);
          console.log(err);
        } else if (err.response.status === 401) {
          toaster.push(
            <Notification type="error" header="Error">
              <Placeholder.Paragraph
                style={{ width: 100, color: "red" }}
                rows={0}
              />
              Kindly check your email and password -- Err Code 401
            </Notification>,
            {
              placement: "topEnd",
            }
          );
        } else {
          alert(err?.message);
        }
      }
    );
  };
  const handleSocialLogin = (res) => {
    if (res?.status === "unknown") {
    } else {
      socialLogin(res);
    }
  };

  const continueBtn = (e) => {
    e.preventDefault();
    let confing = {
      url: ApiUrl.loginInfulencer,
      method: "POST",
      body: {
        email: formData?.email,
        password: formData?.password,
        device_name: "Web",
        username: "Web",
      },
    };
    APIRequest(
      confing,
      (res) => {
        console.log(res.token, "sdfgbg");
        setIsLoading(true);

        localStorage.setItem("token", res?.token);
        localStorage.setItem("user", JSON.stringify(res.user));
        localStorage.setItem("userRole", "INFLUENCER");
        setAuth({
          userRole: "INFLUENCER",
          user: res.user,
          token: res?.token,
        });
        navigate("/influencer-dashboard");
        // window.location.reload();
      },
      (err) => {
        setIsLoading(false);
        if (err.response.status === 422) {
          setValidataionErrors(err.response.data.errors);
          console.log(err);
        } else if (err.response.status === 401) {
          console.log(err);
          toaster.push(
            <Notification type="error" header="Error">
              <Placeholder.Paragraph
                style={{ width: 100, color: "red" }}
                rows={0}
              />{" "}
              Invalid credentials
            </Notification>,
            {
              placement: "topCenter",
            }
          );
        } else {
          alert(err?.response);
          console.log("err++", err.response);
        }
      }
    );
  };

  return (
    <div className="login-wrapper">
      <div className="login-wrapper-inner">
        <div className="left">
          <Slider {...settings}>
            <div className="slider-box">
              <img src={Images.loginSlider1} alt="slider-img" />
              <p>Let me introduce my new skin care routine.</p>
            </div>
            <div className="slider-box">
              <img src={Images.loginSlider2} alt="slider-img" />
              <p>Let me introduce my new skin care routine.</p>
            </div>
            <div className="slider-box">
              <img src={Images.loginSlider3} alt="slider-img" />
              <p>Let me introduce my new skin care routine.</p>
            </div>
            <div className="slider-box">
              <img src={Images.loginSlider4} alt="slider-img" />
              <p>Let me introduce my new skin care routine.</p>
            </div>
          </Slider>
        </div>
        <div className="right">
          <img className="logo" src={Images.logo} alt="logo" />
          <p>Welcome to Dream Star !</p>
          <Form>
            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData?.email}
                placeholder="Enter email"
                onChange={handleOnChange}
              />
              {hasError(validataionErrors, "email")}
            </Form.Group>

            <Form.Group className="mb-3" controlId="password">
              <Form.Label>Password</Form.Label>
              <InputGroup>
                <Form.Control
                  name="password"
                  value={formData?.password}
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  onChange={handleOnChange}
                  className="password-input"
                />

                <InputGroup.Text onClick={togglePasswordVisibility}>
                  {showPassword ? <EyeSlashFill /> : <EyeFill />}
                </InputGroup.Text>
              </InputGroup>
              {hasError(validataionErrors, "password")}
            </Form.Group>

            <Form.Group
              className="mb-3 forgot-btn"
              controlId="formBasicForgotPassword"
            >
              <Form.Text className="text-muted">
                <Link to="/forgot-password">Forgot Password?</Link>
              </Form.Text>
            </Form.Group>
            <ThemeButtom title="Login" handleClick={continueBtn} />
            <p className="button-middle-border">OR</p>

            {/* <Button className="facebook-btn">
              <Facebook size={20} className="me-2" />
              Sign in with Facebook
            </Button> */}
            {/* <FacebookLogin
              appId="807529897062147"
              autoLoad={false}
              fields="name,email,picture"
              callback={handleSocialLogin}
              cssClass="facebook-btn"
              icon={<Facebook size={20} className="me-2" />}
            /> */}
            <Form.Group
              className="mb-3 second-login-btn"
              controlId="formBasicForgotPassword"
            >
              <Form.Text className="text-muted">
                <Link to="/brand">Login As Brand?</Link>
              </Form.Text>
            </Form.Group>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default InfluencerLogin;
